import { Outlet } from 'react-router-dom';
import TopNav from './TopNav';
import { TrialBanner } from '@/components/common/TrialBanner';
import { CarrierCredentialBanner } from '@/components/merchant/CarrierCredentialBanner';
import { ImpersonationBanner } from '@/components/admin/ImpersonationBanner';
import KBWidget from '@/components/merchant/KnowledgeBase/KBWidget';
import KBSidebar from '@/components/merchant/KnowledgeBase/KBSidebar';
import { useKBStore } from '@/stores/kbStore';

export default function DashboardLayout() {
  const isOpen = useKBStore((s) => s.isOpen);

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <ImpersonationBanner />
      <TopNav />
      <TrialBanner />
      <CarrierCredentialBanner />
      <div className="flex flex-1 overflow-hidden">
        <main className="flex-1 overflow-y-auto overflow-x-hidden bg-base-100 p-4 lg:p-6">
          <Outlet />
        </main>
        {isOpen && <KBSidebar />}
      </div>
      <KBWidget />
    </div>
  );
}
